import Rarity from "../../helper/Rarity";
import IngredientCategory from "../../helper/IngredientCategory";

export default {
    ARACHAS: {
        item: 'Arachas Mutagen',
        category: IngredientCategory.GREEN_MUTAGEN,
        maxAmount: 1,
        DC: 18,
        rarity: Rarity.RARE,
    },
    FIEND: {
        item: 'Fiend Mutagen',
        category: IngredientCategory.GREEN_MUTAGEN,
        maxAmount: 1,
        DC: 18,
        rarity: Rarity.RARE,
    },
    FORKTAIL: {
        item: 'Forktail Mutagen',
        category: IngredientCategory.BLUE_MUTAGEN,
        maxAmount: 1,
        DC: 18,
        rarity: Rarity.RARE,
    },
    GHOUL: {
        item: 'Ghoul Mutagen',
        category: IngredientCategory.RED_MUTAGEN,
        maxAmount: 1,
        DC: 18,
        rarity: Rarity.RARE,
    },
    GRAVE_HAG: {
        item: 'Grave Hag Mutagen',
        category: IngredientCategory.GREEN_MUTAGEN,
        maxAmount: 1,
        DC: 18,
        rarity: Rarity.RARE,
    },
    GRIFFIN: {
        item: 'Griffin Mutagen',
        category: IngredientCategory.GREEN_MUTAGEN,
        maxAmount: 1,
        DC: 18,
        rarity: Rarity.RARE,
    },
    KATAKAN: {
        item: 'Katakan Mutagen',
        category: IngredientCategory.RED_MUTAGEN,
        maxAmount: 1,
        DC: 18,
        rarity: Rarity.RARE,
    },
    NEKKER: {
        item: 'Nekker Mutagen',
        category: IngredientCategory.RED_MUTAGEN,
        maxAmount: 1,
        DC: 15,
        rarity: Rarity.UNCOMMON,
    },
    NIGHTWRAITH: {
        item: 'Nightwraith Mutagen',
        category: IngredientCategory.GREEN_MUTAGEN,
        maxAmount: 1,
        DC: 18,
        rarity: Rarity.RARE,
    },
    NOONWRAITH: {
        item: 'Noonwraith Mutagen',
        category: IngredientCategory.GREEN_MUTAGEN,
        maxAmount: 1,
        DC: 18,
        rarity: Rarity.RARE,
    },
    EKHIDNA: {
        item: 'Ekhidna Mutagen',
        category: IngredientCategory.BLUE_MUTAGEN,
        maxAmount: 1,
        DC: 18,
        rarity: Rarity.RARE,
    },
    TROLL: {
        item: 'Troll Mutagen',
        category: IngredientCategory.GREEN_MUTAGEN,
        maxAmount: 1,
        DC: 18,
        rarity: Rarity.RARE,
    },
    WEREWOLF: {
        item: 'Werewolf Mutagen',
        category: IngredientCategory.RED_MUTAGEN,
        maxAmount: 1,
        DC: 18,
        rarity: Rarity.RARE,
    },
    WRAITH: {
        item: 'Wraith Mutagen',
        category: IngredientCategory.GREEN_MUTAGEN,
        maxAmount: 1,
        DC: 15,
        rarity: Rarity.UNCOMMON,
    },
    WYVERN: {
        item: 'Wyvern Mutagen',
        category: IngredientCategory.RED_MUTAGEN,
        maxAmount: 1,
        DC: 18,
        rarity: Rarity.RARE,
    },
}